// Components
import Field from 'components/form/field'
import { TextInput } from 'components/form/text-input'
// Modules
import { DI } from 'modules'
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import * as React from 'react'
import { Link } from 'components/link'
import CheckboxInput from 'components/form/checkbox-input'
import { privacyPolicy, tos } from 'config/routes'

const PaymentEmail = ({
  actions,
  common: { strings },
  form: { email, agreeTerms, newsletter_notify },
  onValidateForm,
  showAction,
}) => {
  const openSignInModalHandler = ev => {
    ev.preventDefault()
    actions.common.openSignInModal()
  }

  return (
    <PaymentBlock
      text={
        <>
          {strings['signup.signin.before_link_2']}
          <a
            href="#"
            onClick={openSignInModalHandler}
            style={{ textDecoration: 'none', color: '#77bc1f' }}
          >
            {strings['signup.signin.link.text_2']}
          </a>
        </>
      }
      title={strings['signup.title']}
    >
      <PaymentBlockFields>
        <Field label="Email">
          <TextInput
            disabled={!showAction}
            isRequired
            name="email"
            onValidateForm={onValidateForm}
            reactOnChange
            type="email"
            value={email}
          />
        </Field>
        <div className="field field--su-checkbox">
          <CheckboxInput
            checked={newsletter_notify}
            name="newsletter_notify"
            onValidateForm={onValidateForm}
          >
            {strings['signup.newsletters.text']}
          </CheckboxInput>
        </div>

        <div className="field field--su-checkbox">
          <CheckboxInput
            checked={agreeTerms}
            disabled={!showAction}
            isRequired
            name="agreeTerms"
            onValidateForm={onValidateForm}
          >
            {strings['signup.terms.text']}{' '}
            <Link rel="noreferrer noopenner" target="_blank" to={tos.getPath()}>
              {strings['signup.terms.link']}
            </Link>
            {', '}
            {strings['signup.privacy.text']}
            <Link
              rel="noreferrer noopenner"
              target="_blank"
              to={privacyPolicy.getPath()}
            >
              {strings['signup.privacy.link']}
            </Link>
          </CheckboxInput>
        </div>

        {showAction && (
          <div
            className="popup-button"
            style={{ maxWidth: '100px', margin: '20px 0 0' }}
          >
            <button
              className="button"
              disabled={!agreeTerms}
              type="submit"
              data-action-name="confirmation email"
            >
              {strings['signup.signin.next']}
            </button>
          </div>
        )}
      </PaymentBlockFields>
    </PaymentBlock>
  )
}

export default DI(['common'])(PaymentEmail)
